import React from "react"
import { useIntl } from "react-intl"
import { Alert } from "@walmart-web/livingdesign-components"
import { validateValuePercentage } from "components/Transactional/GrowthProfiling/utils"
import { CustomerDescriptionResponse } from "components/Transactional/GrowthProfiling/Shared/interfaces"
import SkeletonWrapper from "components/Shared/SkeletonWrapper"
import { useFetchData } from "components/Shared/Hooks/react-query/useFetchData"
import { FiltersType } from "components/Shared/GlobalFilter/context/interfaces"
import CustomerDescriptionSkeleton from "./CustomerDescriptionSkeleton"
import { getCustomerDescription } from "./service"
import { DateInterval } from "../PhronesisCalendar/PhronesisCalendar.utils"
import "./CustomerDescription.styles.scss"

export type CustomerDescriptionBaseProps = {
	dateInterval: DateInterval
	filters: FiltersType
}

export const CustomerDescriptionBase = (
	props: CustomerDescriptionBaseProps
) => {
	const intl = useIntl()

	const { dateInterval, filters } = props

	const { data: customerDescription, isLoading } = useFetchData<
		CustomerDescriptionResponse | undefined
	>(
		"retrieveCustomerDescription",
		getCustomerDescription,
		{
			filters,
			dateInterval,
		},
		{
			retry: false,
			enabled: true,
		}
	)

	function shouldShowDescription() {
		return customerDescription && customerDescription?.totalCustomers > 0
	}

	if (!isLoading && !shouldShowDescription()) {
		return null
	}

	return (
		<div data-testid="customer-description" className="customer-description">
			<SkeletonWrapper
				isLoading={isLoading}
				skeleton={<CustomerDescriptionSkeleton />}
			>
				<Alert className="customer-description-alert" variant="info">
					{intl.formatMessage(
						{
							id: validateValuePercentage(
								customerDescription?.percentageByCustomers,
								"phronesis.transactional.application.growth-profiling.chart.description.idenCustomer",
								"phronesis.transactional.application.growth-profiling.chart.description.idenCustomer.lessThanOne"
							),
						},
						{
							totalCustomers: intl.formatNumber(
								customerDescription?.totalCustomers,
								{
									style: "decimal",
								}
							),
							percentageSalesByCustomers: intl.formatNumber(
								customerDescription?.percentageByCustomers,
								{
									style: "percent",
									minimumFractionDigits: 1,
								}
							),
							br: <br />,
							b: (str: any) => <b>{str} </b>,
						}
					)}
				</Alert>
			</SkeletonWrapper>
		</div>
	)
}
